import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withNoIncrementalHydration
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './views/layout/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  KeyValuePipe,
  SlicePipe,
} from '@angular/common';
import { LoginService } from './components/login/service/login.service';
import {
  provideHttpClient,
  withInterceptors,
  withJsonpSupport,
  withXhr
} from '@angular/common/http';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { VerifyComponent } from './components/verify/verify.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { MainComponent } from './views/layout/main/main.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { authuserInterceptor } from './intercep/authuser.interceptor';
import { RouterModule } from '@angular/router';
import { UnauthorizedComponent } from './views/layout/unauthorized/unauthorized.component';
import { PermissionService } from './permission.service';

import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';

import { NgxStripeModule } from 'ngx-stripe';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AIAssistComponent } from './views/layout/aiassist/aiassist.component';
import { AutocompleteComponent } from './views/layout/aiassist/autocomplete/autocomplete.component';
import { BotComponent } from './views/layout/aiassist/bot/bot.component';
import { AssistBotService } from './views/layout/aiassist/assist-bot.service';

import { SettingsComponent } from './views/layout/settings/settings.component';
import { SettingsService } from './views/layout/settings/service/settings.service';
import { PageNotFoundComponent } from './views/layout/page-not-found/page-not-found.component';

import { DashboardComponent } from './views/layout/dashboard/dashboard.component';
import { MainService } from './views/layout/main/service/mainservice';


import { SharedModule } from './modules/shared/shared.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DialogService } from './services/dialog.service';
import {
  InfiniteScrollDirective,
  
} from 'ngx-infinite-scroll';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { DocEditorViewerComponent } from './components/doc-editor-viewer/doc-editor-viewer.component';
import { AppToastComponent } from './components/toast/toast.component';
import { AppMessageService } from './services/Messageservice';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    SignUpComponent,
    VerifyComponent,
    ForgotPasswordComponent,
    MainComponent,
    HeaderComponent,
    SidebarComponent,
    UnauthorizedComponent,
    AIAssistComponent,
    AutocompleteComponent,
    BotComponent,

    SettingsComponent,
    PageNotFoundComponent,

    DashboardComponent,

    ConfirmDialogComponent,
  ],
  imports: [
    PhoneNumberInputComponent,
    DocEditorViewerComponent,
    AppToastComponent,
    BrowserModule,
    CommonModule,

    AppRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    InfiniteScrollDirective,

    BrowserAnimationsModule,
    NgxStripeModule.forRoot(
      'pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3',
    ),
  ],

  providers: [
    provideClientHydration(withNoIncrementalHydration()),
    AppMessageService,
    provideHttpClient(withXhr(), 
      withJsonpSupport(),
      withInterceptors([authuserInterceptor]),
    ),
    provideAnimations(),
    provideAnimationsAsync(),
    PermissionService,
    LoginService,

    DatePipe,
    DecimalPipe,
    SlicePipe,
    KeyValuePipe,

    AssistBotService,

    SettingsService,
    MainService,

    DialogService,
    //provideNgxStripe(),

    //provideNgxStripe("pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3"),
    provideCharts(withDefaultRegisterables()),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
